import { action } from 'satcheljs';

/**
 * Action called to toggle moveToFolderNodeViewState.
 */
export default action('toggleMoveToFolderNodeViewState', (folderId: string) => ({ folderId }));
